var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"mr-2 d-none d-xl-inline-block"},[_vm._t("icon")],2),_c('div',{staticClass:"w-100 mr-2"},[_vm._t("progress-bar")],2),_vm._t("dropdown")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }